import { SVGProps } from 'react';

const DocumentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='36'
      height='39'
      viewBox='0 0 36 39'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_3395_154154)'>
        <path
          d='M25.875 39H10.125C4.5375 39 0 34.425 0 28.875V13.125C0 7.53749 4.5375 2.99998 10.125 2.99998H25.875C31.425 2.99998 36 7.53749 36 13.125V28.875C36 34.425 31.4625 39 25.875 39Z'
          fill='#C0F9FC'
        />
        <path
          d='M24.7501 36.75H11.2126C6.03765 36.75 1.83765 32.55 1.83765 27.375V27.3375C1.83765 22.1625 6.03765 18 11.2126 18H24.7501C29.9251 18 34.0876 22.2 34.0876 27.3375V27.375C34.0876 32.55 29.9251 36.75 24.7501 36.75Z'
          fill='#8CE6F4'
        />
        <path
          d='M27.3679 33.6918H11.2945C11.1328 33.6918 11.0035 33.6595 10.8741 33.5948C10.7447 33.5301 10.6154 33.4654 10.5183 33.3361C10.4213 33.2391 10.3243 33.1097 10.2596 32.9803C10.1949 32.851 10.1626 32.6893 10.1626 32.5599V16.4219C10.1626 16.3248 10.1949 16.2278 10.2273 16.1308C10.2596 16.0338 10.3243 15.9367 10.389 15.8721L17.3422 8.98348C17.504 8.82178 17.698 8.7571 17.892 8.7571H27.3679C27.5296 8.7571 27.659 8.78944 27.7883 8.85412C27.9177 8.9188 28.047 8.98348 28.1441 9.11284C28.2411 9.20987 28.3381 9.33923 28.4028 9.46859C28.4675 9.59796 28.4998 9.75966 28.4998 9.88902V32.5922C28.4998 32.7539 28.4675 32.8833 28.4028 33.0127C28.3381 33.142 28.2734 33.2714 28.1441 33.3684C28.047 33.4654 27.9177 33.5625 27.7883 33.6271C27.659 33.6595 27.5296 33.6918 27.3679 33.6918Z'
          fill='#3EAFCE'
        />
        <path
          d='M26.7212 32.9804H10.6478C10.4861 32.9804 10.3567 32.948 10.2274 32.8833C10.098 32.8187 9.96864 32.754 9.87162 32.6246C9.77459 32.5276 9.67757 32.3982 9.61289 32.2689C9.54821 32.1395 9.51587 31.9778 9.51587 31.8484V15.7427C9.51587 15.6457 9.54821 15.5487 9.58055 15.4517C9.61289 15.3546 9.67757 15.2576 9.74225 15.1929L16.6955 8.27201C16.8572 8.11031 17.0513 8.04562 17.2453 8.04562H26.7212C26.8829 8.04562 27.0122 8.07796 27.1416 8.14265C27.271 8.20733 27.4003 8.27201 27.4973 8.40137C27.5944 8.49839 27.6914 8.62776 27.7561 8.75712C27.8207 8.88648 27.8531 9.04819 27.8531 9.17755V31.8808C27.8531 32.0425 27.8207 32.1718 27.7561 32.3012C27.6914 32.4306 27.6267 32.5599 27.4973 32.6569C27.4003 32.754 27.271 32.851 27.1416 32.9157C27.0446 32.9804 26.8829 32.9804 26.7212 32.9804Z'
          fill='#F1F2F2'
        />
        <path
          d='M9.67746 15.6134H15.9516C16.1133 15.6134 16.2426 15.581 16.4043 15.5163C16.5337 15.4517 16.6631 15.387 16.7924 15.2576C16.8895 15.1606 16.9865 15.0312 17.0512 14.9019C17.1158 14.7725 17.1482 14.6108 17.1482 14.4814V8.20733C17.1482 8.17499 17.1482 8.14265 17.1158 8.11031C17.0835 8.07796 17.0835 8.07796 17.0512 8.04562C17.0188 8.04562 16.9865 8.04562 16.9541 8.04562C16.9218 8.04562 16.8895 8.07796 16.8571 8.07796L9.58044 15.3546C9.5481 15.387 9.5481 15.4193 9.5481 15.4517C9.5481 15.484 9.5481 15.5163 9.5481 15.5487C9.5481 15.581 9.58044 15.6134 9.61278 15.6134C9.61278 15.6134 9.64512 15.6134 9.67746 15.6134Z'
          fill='#BCBEC0'
        />
        <path
          d='M25.2982 18.33H12.3296V19.8824H25.2982V18.33Z'
          fill='#BCBEC0'
        />
        <path
          d='M25.2982 21.4024H12.3296V22.9547H25.2982V21.4024Z'
          fill='#BCBEC0'
        />
        <path
          d='M25.2982 24.4748H12.3296V26.0271H25.2982V24.4748Z'
          fill='#BCBEC0'
        />
        <path
          d='M25.2982 27.5471H12.3296V29.0995H25.2982V27.5471Z'
          fill='#BCBEC0'
        />
      </g>
      <defs>
        <clipPath id='clip0_3395_154154'>
          <rect width='36' height='39' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DocumentIcon;
